import { createAction } from "redux-actions";
import { SET_LOYALTY_ENABLE_COMPLIANCE_VARIANT } from "../constants";

const setEnableComplianceVariant = createAction(
  SET_LOYALTY_ENABLE_COMPLIANCE_VARIANT
);

export default setEnableComplianceVariant;
